import React, { useRef, useState, useEffect } from 'react'
import {Form, Button, Card, Alert, Container, Row, Col } from 'react-bootstrap'
import { Link, useHistory } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext'
import app from '../firebase'
import { getAllUsers } from '../contexts/DbContext'
import DataTable from 'react-data-table-component';

const columns = [
    {
        name: 'Name',
        selector: row => row.name,
    },
    {
        name: 'email',
        selector: row => row.email,
    },
    {
        name: 'Role',
        selector: row => row.role,
    },
];

 const UserManagement = () =>  {
    const emailRef = useRef();
    const passwordRef = useRef();
    const passwordConfirmRef = useRef();
    const nameRef = useRef();
    const roleRef = useRef();
    const { singUp, currentUser, isAdmin } = useAuth();
    const [error, setError ] = useState("")
    const [users, setUesrs ] = useState([]);
    const [ loading, setLoading ] = useState(false);
    const history = useHistory();

    const handleSubmit = async(e) => {
        e.preventDefault();

        if(passwordRef.current.value !== passwordConfirmRef.current.value){
            return setError("Passwords are not match");
        }

        try {
            setError("");
            setLoading(true)
            const user = {
                email: emailRef.current.value,
                password: passwordRef.current.value,
                name: nameRef.current.value,
                role: roleRef.current.value
            }
            const userDate = await singUp(user)
            // Add error check base on userDate 

        } catch (error) {
            console.log(error.message)
            setError(error.message)
        }
        setLoading(false)
        e.target.reset()
    }

    useEffect( async() => {
        setUesrs(await getAllUsers())
    }, [loading])

    if(isAdmin()){
        return (
            <>
            <Container fluid className="mt-3">
            {error && <Alert variant="danger">{error}</Alert> }
                <Row>
                    <Col xs="12" ms="12" md="4" lg="4" className="mb-2">
                        <Card className="">
                            <Card.Body>
                            <Card.Title className="text-center mb-4">Registration</Card.Title>
                                <Form onSubmit={handleSubmit}>
                                    <Form.Group className="mb-3" id="name">
                                        <Form.Label>Name</Form.Label>
                                        <Form.Control type="text" ref={nameRef} required />
                                    </Form.Group>
                                    <Form.Group className="mb-3" id="email">
                                        <Form.Label>Email</Form.Label>
                                        <Form.Control type="email" ref={emailRef} required />
                                    </Form.Group>
                                    <Form.Group className="mb-3" id="role">
                                        <Form.Label>Role</Form.Label>
                                        <Form.Control as="select" defaultValue="Chose..." ref={roleRef} required >
                                            <option value="">Choose..</option>
                                            <option value="sampler">Sampler</option>
                                            <option value="admin">Admin</option>
                                        </Form.Control>
                                    </Form.Group>
                                    <Form.Group className="mb-3" id="password">
                                        <Form.Label>Password</Form.Label>
                                        <Form.Control type="password" ref={passwordRef} required />
                                    </Form.Group>
                                    <Form.Group className="mb-3" id="password-confirm">
                                        <Form.Label>Password Confirmation</Form.Label>
                                        <Form.Control type="password" ref={passwordConfirmRef} required />
                                    </Form.Group>
                                    <Button disabled={loading} className="btn-custome-primary w-100 mt-2" type="submit">Submit</Button>
                                </Form>
                            </Card.Body>
                        </Card>  
                    </Col>
                    <Col>
                        <Card className="">
                            <Card.Body>
                                <Card.Title className="text-center mb-4">Users</Card.Title>
                                <DataTable
                                    columns={columns}
                                    data={users}
                                    progressPending={loading}
                                    pagination
                                />
                                
                            </Card.Body>
                        </Card>  
                    </Col>
                </Row>
            </Container>
            </>
        )
    } else {
        return (<> <h1>You don't have access</h1></>)
    }

    
}

export default UserManagement;
